import { render, staticRenderFns } from "./storeInfo.vue?vue&type=template&id=704a08d0&scoped=true"
import script from "./storeInfo.vue?vue&type=script&lang=js"
export * from "./storeInfo.vue?vue&type=script&lang=js"
import style0 from "./storeInfo.vue?vue&type=style&index=0&id=704a08d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a08d0",
  null
  
)

export default component.exports